/**
 * Validate if a name is in accepted format.
 *
 * @param {string} name
 */
const isNameValid = (name) => {
    const regex = /([a-zæøåA-ZÆØÅ]+\s?\b){2,}/;
    return regex.test(name);
};
export default isNameValid;
